import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import ArticleImage from "@components/elements/V2/ArticleImage"

const StoryblokImage = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.ArticleImage>) => {
  return (
    <ArticleImage
      imageUrl={blok.image.filename}
      imageAlt={blok.image.alt}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokImage
